import '../../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';

import { MUTATION } from '../../../gql-operations';
import { Link } from 'react-router-dom';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';

import useRedirectErrors from '../../../errors/useRedirectErrors';
import AuthLayout from '../AuthLayout';

const ForgotPasswordPage = ({ history }) => {
    const {t: lnT} = useTranslation();

    const { passingErrors } = useRedirectErrors();
    const [forgotPasswordMail, { data, error, loading }] = useMutation(MUTATION.FORGOT_PASSWORD_SEND_EMAIL, {
        onCompleted: res => {
            // console.log('this is forgotPassword response', res.forgotPasswordMail);
            if (res.forgotPasswordMail) {
                setTimeout(() => {
                    history.push('/login', {
                        forgotResponse: res.forgotPasswordMail
                    });
                }, 5000);
                // <Link to={'/login'} params={{forgotResponse}}>Create Account</Link>
            }
        },
        onError: res => {
            passingErrors(res);
        },
    });

    const renderMessage = () => {
        if (data && data.forgotPasswordMail) {
            return (
                <div className="auth-alert auth-alert--success">
                    <span className="auth-alert-icon">✓</span>
                    <span className="auth-alert-body">{lnT('auth:emailSentSuccessfullyPleaseCheckYourInbox')}</span>
                </div>
            );
        } else if (error) {
            return (
                <div className="auth-alert auth-alert--error">
                    <span className="auth-alert-icon">⚠</span>
                    <span className="auth-alert-body">
                        {error.graphQLErrors.length > 0
                            ? error.graphQLErrors.map(x => x.message).join(', ')
                            : lnT('auth:serverErrorWeLlBeBackSoon')}
                    </span>
                </div>
            );
        }
    };

    return (
        <AuthLayout>
            <Formik
                initialValues={{
                    email: ''
                }}
                onSubmit={(values, actions) => {
                    forgotPasswordMail({
                        variables: {
                            data: {
                                email: values.email
                            }
                        }
                    });

                    actions.setSubmitting(false);
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().email().required(lnT('auth:youNeedToPutAProperEmail'))
                })}
            >
                {({ values, handleSubmit, handleChange, handleBlur, errors, touched }) => (
                    <>
                        <h1 className="auth-title">{lnT('auth:forgotYourPassword')}</h1>
                        <p className="auth-subtitle">{lnT('auth:donTWorryJustEnterYourEmail')}</p>

                        {renderMessage()}

                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="auth-field">
                                <input
                                    name="email"
                                    type="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    placeholder={lnT('common:email')}
                                    autoCorrect="off"
                                />
                                <ErrorMessage
                                    name="email"
                                    render={msg => (
                                        <div id="email" className="error">
                                            {msg}
                                        </div>
                                    )}
                                />
                            </div>

                            <button type="submit" className="auth-submit">{lnT('auth:resetPassword')}</button>
                        </form>

                        <hr className="auth-divider" />

                        <div className="auth-footer">{lnT('auth:backTo')}<Link to={'/login'}>{lnT('auth:signIn')}</Link>
                        </div>
                    </>
                )}
            </Formik>
        </AuthLayout>
    );
};

export default ForgotPasswordPage;
